var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSliderField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 5,
    viewBox: "0 0 15 5",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r79f8q0voa",
    d: "M0 0.005L7.29 0.005 7.29 1.41 0 1.41z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-153 -771) translate(121 756) translate(32 11) translate(0 5) translate(0 1.045)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a4co3z86sb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r79f8q0voa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M7.138.712c0 .249.053.485.147.698H.527C.237 1.41 0 1.173 0 .883V.532C0 .242.237.005.527.005H7.29c-.098.216-.152.455-.152.707",
    mask: "url(#a4co3z86sb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.585 1.687L13.976 1.687",
    transform: "translate(-153 -771) translate(121 756) translate(32 11) translate(0 5)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.585 1.687L13.976 1.687",
    transform: "translate(-153 -771) translate(121 756) translate(32 11) translate(0 5)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#595959",
    d: "M10.585 1.758c0 .12-.012.238-.036.352-.163.783-.857 1.371-1.688 1.371-.55 0-1.039-.257-1.354-.658l-.037-.05c-.037-.048-.07-.1-.1-.153l-.03-.054c-.02-.036-.038-.073-.054-.11-.095-.214-.148-.45-.148-.698 0-.252.054-.492.152-.708.033-.075.072-.147.116-.215L7.44.784c.01-.017.023-.033.036-.05L7.5.701 7.52.677 7.55.64c.013-.016.026-.031.04-.045l.056-.06.048-.045.026-.023c.03-.027.061-.053.094-.078L7.84.37l.058-.041c.046-.031.093-.06.142-.087l.074-.037.07-.032c.022-.01.045-.02.07-.028l.031-.012c.05-.018.102-.033.155-.047L8.513.07h.002l.084-.015c.033-.005.067-.009.1-.012.018-.002.036-.004.054-.004l.035-.002.073-.002h.004l.08.002.075.006.044.005c.015.001.03.002.043.005l.041.006.034.007.038.007c.02.004.04.008.058.014l.02.004.042.012.041.013c.047.014.094.031.138.05l.05.022c.032.013.064.028.094.045l.044.024c.055.03.107.064.158.102l.032.023c.05.036.096.075.14.117l.036.035.043.044.04.045.01.01.04.05c.168.207.287.454.343.723.024.114.036.232.036.353z",
    transform: "translate(-153 -771) translate(121 756) translate(32 11) translate(0 5)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderField);
export default __webpack_public_path__ + "static/media/slider-field.f1d0f0b0.svg";
export { ForwardRef as ReactComponent };